import { SectionHeader } from '@core/components';
import { withAppInsightsTracking } from '@core/logging/withAppInsightsTracking';
import { Heading, Section, Text } from '@soteria/design-system-ve';

import type { EntityType } from '../domain';

import * as styles from './ModerationActionsTab.css';

interface ModerationActionsTabProps {
  entityId: string;
  entityType: EntityType;
  isEntityAdmin: boolean;
  sectionTitle?: string;
}

/**
 * Moderation Actions tab component
 *
 * Currently stubbed - will be implemented with moderation-specific actions
 * that differ from general classification actions
 */
function ModerationActionsTabComponent({ sectionTitle }: ModerationActionsTabProps) {
  return (
    <Section spacing="large">
      <SectionHeader description="Configure moderation-specific actions for this community." title={sectionTitle || 'Moderation Actions'} />

      <div className={styles.emptyState}>
        <div>
          <Heading level="h3">Moderation Actions</Heading>
          <Text className={styles.emptyStateText}>No API Integration</Text>
          <Text className={styles.emptyStateDescription}>
            Moderation actions management will be available once the moderation actions API is integrated. This will provide moderation-specific actions
            separate from general classification actions.
          </Text>
        </div>
      </div>
    </Section>
  );
}

export const ModerationActionsTab = withAppInsightsTracking(ModerationActionsTabComponent, 'ModerationActionsTab');
